/**
 * Reads the @tag out of a scanned Liminal profile QR: the code a guest shows
 * from Profile → Share in the app.
 *
 * The pattern is the mobile scanner's `LIMINAL_PROFILE`, copied exactly from
 * application/mobile/src/features/scan/utils/classifyScannedCode.ts, so a code
 * one scanner reads the other reads too: `liminal://u/<tag>`,
 * `liminal-dev://u/<tag>`, or the universal link on our API hosts, each with
 * an optional trailing slash, query or fragment. Change both or neither.
 *
 * Anything else (a Pix BR code, another site's link, free text) is not a
 * profile link and reads as null.
 */

/** `liminal://u/<tag>`, `liminal-dev://u/<tag>`, or the universal-link form on our API hosts. */
const LIMINAL_PROFILE =
  /^(?:liminal(?:-dev)?:\/\/|https:\/\/(?:testnet-)?api\.liminal\.cash\/)u\/([A-Za-z0-9_.-]+)\/?(?:[?#].*)?$/;

export interface ProfileLink {
  /** The profile's @tag, without the @. */
  readonly tag: string;
}

export function parseProfileLink(payload: string): ProfileLink | null {
  const match = LIMINAL_PROFILE.exec(payload.trim());
  if (match === null) return null;
  return { tag: match[1] };
}
